import { generate } from './helpers';

export const THRESHOLD = generate();
